import { createContext, useContext } from "react"
import type { ProductCardHook } from "../components/ProductCard/types"

// Create the ProductCard context
const ProductCardContext = createContext<ProductCardHook>({} as ProductCardHook)

// Create the useProductCard hook
const useProductCard = (): ProductCardHook => {
  return useContext(ProductCardContext)
}

// Export the ProductCard context and useProductCard hook
export { ProductCardContext, useProductCard }
